import { CANCELLATION_REASON } from '@/config/saleStatus';

export const PENALTY_REASONS = {
  LATE_SHIPMENT: 'LATE_SHIPMENT',
  UNDISCLOSED_DEFECT: 'UNDISCLOSED_DEFECT',
};

const PENALTY_REASON_TRANSLATIONS = {
  [PENALTY_REASONS.LATE_SHIPMENT]: 'sales.penalty.reason.lateShipment',
  [PENALTY_REASONS.UNDISCLOSED_DEFECT]: 'sales.penalty.reason.undisclosedDefect',
};

const normalizePenaltyReason = (reason) => {
  if (!reason || typeof reason !== 'string') {
    return null;
  }

  const upperCaseReason = reason.toUpperCase();

  if (PENALTY_REASONS[upperCaseReason]) {
    return PENALTY_REASONS[upperCaseReason];
  }

  switch (upperCaseReason) {
    case CANCELLATION_REASON.SELLER_TIMEOUT:
      return PENALTY_REASONS.LATE_SHIPMENT;
    case CANCELLATION_REASON.VERIFICATION_FAILED:
      return PENALTY_REASONS.UNDISCLOSED_DEFECT;
    default:
      return null;
  }
};

export const resolvePenaltyReason = (penalty, sale) => {
  if (!penalty) {
    return null;
  }

  const directReason = normalizePenaltyReason(
    penalty.reason || penalty.reasonCode || penalty.code
  );

  if (directReason) {
    return directReason;
  }

  const cancellationReason = sale?.cancellationReason || penalty.cancellationReason;
  if (cancellationReason) {
    return normalizePenaltyReason(cancellationReason);
  }

  return null;
};

export const getPenaltyReasonTranslationKey = (reason) => {
  if (!reason) {
    return 'sales.penalty.reason.unknown';
  }
  return PENALTY_REASON_TRANSLATIONS[reason] || 'sales.penalty.reason.unknown';
};
